import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { LoadingStatus } from '../ProgressViewer/ProgressViewer';
import { useStyles } from './MainLineView.styles';
import { BlueprintFlowData } from '../../types/flowScenario';
import { useMainLineViewData } from './useMainLineViewData';
import React from 'react';

export type MainLineViewProps = {
  lodingStatus: LoadingStatus;
  blueprintFlowData: BlueprintFlowData | undefined;
};

export const MainLineView: React.FC<MainLineViewProps> = ({ lodingStatus, blueprintFlowData }) => {
  const styles = useStyles();
  const mainLineViewComponent = useMainLineViewData(
    blueprintFlowData,
    'blueprint'
  ).maineLineViewComponent;

  return lodingStatus === 'pending' ? (
    <Skeleton className={styles.mainLineViewSkeleton}>
      <Skeleton className={styles.mainLineViewSkeleton}>
        <SkeletonItem size={128} />
        <SkeletonItem size={128} />
        <SkeletonItem size={128} />
      </Skeleton>
      <Skeleton className={styles.mainLineViewSkeleton}>
        <SkeletonItem size={128} />
        <SkeletonItem size={128} />
        <SkeletonItem size={128} />
      </Skeleton>
    </Skeleton>
  ) : (
    <>{mainLineViewComponent}</>
  );
};
